import { NotificationSource } from "./notificationSource";

export interface TransportOrderNotificationListQueryParameters {
    employeeId?: string;
    source?: number;
    states?: TransportOrderNotificationState[];
    page?: number;
    pageSize?: number;
    sortField?: string;
    sortOrder?: string;
}

export interface TransportOrderNotificationListItemDto {
    id: string;
    message: number;
    state: number;
    orderState: number;
    source: NotificationSource;
    createdDateTime: string;
    modifiedDateTime: string;
    employeeId: string;
    createdEmployeeId: string;
    modifiedEmployeeId: string;
    vehicleRegisterNumber?: string;
}

export enum TransportOrderNotificationState {
    Created = 0,
    Notified = 1,
    Confirmed = 2
}

export const UnconfirmedNotificationStates = [
    TransportOrderNotificationState.Created,
    TransportOrderNotificationState.Notified
];
